import React from 'react'

const BlueButton = ({Buttontext,id,onClick,className,style,icon}) => {
  return (
  <button  className={className} id={id} onClick={onClick}  style={style}><span className='pe-2'>{icon}</span>{Buttontext}</button>
  )
}

export default BlueButton